var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M18.6,36.7c2,1.1,4.4,1.1,6.4,0c0.6-0.3,0.9-0.9,0.9-1.5V17.4c0-1.4-0.7-2.7-1.9-3.4l-0.6-0.3v-0.5 c0.5-0.1,0.9-0.4,1.1-0.8l4.1,2.1c0.5,0.2,1.1,0,1.4-0.5c0.2-0.5,0-1.1-0.5-1.4l0,0L25,10.4l3.4-0.8c0.5-0.1,0.8-0.5,0.8-1V8.4 c0-0.3-0.2-0.5-0.4-0.6c-0.2-0.2-0.5-0.2-0.8-0.2l-6.1,1.4h-0.1c-0.8-0.1-1.5,0.5-1.6,1.3c-2.9,0.5-5,3-5,5.9v10.6 c-0.2,0.2-0.3,0.5-0.3,0.8v3.3c0,0.2,0.2,0.3,0.4,0.3h1.8c0.1,0,0.1-0.1,0.1-0.2v-3.4c0-0.2-0.1-0.5-0.2-0.7V16.4 c0-1.9,1.3-3.6,3.2-4v1.3L19.6,14c-1.2,0.7-1.9,2-1.9,3.4v17.8C17.7,35.8,18,36.4,18.6,36.7z M18.9,29.8h-0.5v-0.6h0.3 c2,0.6,4.2,0.6,6.2,0h0.3v0.6h-0.5C22.8,30.4,20.8,30.4,18.9,29.8z M18.4,28.5V26h0.3c2,0.6,4.2,0.6,6.2,0h0.3v2.4h-0.5 c-1.9,0.6-3.9,0.7-5.8,0.1L18.4,28.5z M21.1,11.6c0,0.9,0.7,1.6,1.6,1.7v0.9l0,0c-0.5,0.4-1.3,0.4-1.8,0l0,0v-3.6 c0-0.5,0.4-0.9,0.9-0.9c0,0,0,0,0,0h0.5C21.5,9.9,21,10.7,21.1,11.6z M29.2,13.2c0.1,0,0.2,0.2,0.1,0.4h-0.4l-4.1-2v-0.6L29.2,13.2z  M23.3,9.4l4.9-1.1c0.2,0,0.3,0.1,0.3,0.3c0,0,0,0,0,0l0,0c0,0.2-0.1,0.3-0.2,0.3l-4.3,1l-0.6-0.4L23.3,9.4z M15.9,27.2h0.2 c0.2,0,0.4,0.3,0.4,0.5v2.9h-0.9v-3C15.6,27.5,15.7,27.2,15.9,27.2L15.9,27.2z M16.3,16.4v10H16V16.2c0-2.5,1.7-4.7,4.2-5.1v0.5 C17.9,12,16.3,14,16.3,16.4z M18.4,17.4c0-1.2,0.6-2.2,1.6-2.8h0.2l0.3,0.4c0.8,0.5,1.7,0.5,2.5,0c0.2-0.1,0.3-0.3,0.4-0.4h0.2 c0.5,0.3,0.9,0.7,1.2,1.2c0.2,0.5,0.4,1,0.4,1.6V20h-0.5c-1.9,0.6-3.9,0.6-5.8,0h-0.5V17.4z M18.9,25.5h-0.5v-4.7h0.3 c2,0.6,4.2,0.6,6.2,0h0.3v4.6h-0.5C22.8,26,20.8,26,18.9,25.5z M18.4,35.1v-4.7h0.3c2,0.6,4.2,0.7,6.2,0.1h0.3v4.7 c0,0.4-0.2,0.7-0.5,0.9l0,0c-1.8,0.9-4,0.9-5.8,0C18.6,35.9,18.4,35.5,18.4,35.1z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M20.2,11.1c-2.5,0.4-4.2,2.6-4.2,5.1v10.2h0.3v-10c0-2.3,1.6-4.3,3.9-4.8V11.1z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#A1A1A1",
  d: "M20.9,10.6v3.6l0,0c0.5,0.4,1.3,0.4,1.8,0l0,0v-0.9c-0.9-0.1-1.6-0.8-1.6-1.7c-0.1-0.8,0.4-1.6,1.2-1.9h-0.5 C21.3,9.6,20.9,10.1,20.9,10.6C20.9,10.6,20.9,10.6,20.9,10.6z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#A1A1A1",
  d: "M15.6,30.5h0.9v-2.9c0-0.2-0.2-0.5-0.4-0.5h-0.3c-0.1,0-0.2,0.2-0.2,0.3V30.5z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M25.2,29.8v-0.6h-0.3c-2,0.6-4.2,0.6-6.2,0h-0.3v0.6h0.5c1.9,0.6,3.9,0.6,5.8,0H25.2z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M24.7,25.5h0.5v-4.7h-0.3c-2,0.6-4.2,0.6-6.2,0h-0.3v4.6h0.5C20.8,26,22.8,26,24.7,25.5z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M24.7,28.5h0.5V26h-0.3c-2,0.6-4.2,0.6-6.2,0h-0.3v2.4h0.5C20.8,29.1,22.8,29.1,24.7,28.5z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2724A",
  d: "M18.9,36c1.8,0.9,4,0.9,5.8,0l0,0c0.3-0.2,0.5-0.5,0.5-0.9v-4.7h-0.3c-2,0.6-4.2,0.6-6.2,0h-0.3v4.7 C18.4,35.5,18.6,35.9,18.9,36z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2724A",
  d: "M18.9,20.2c1.9,0.6,3.9,0.6,5.8,0h0.5v-2.8c0-0.6-0.2-1.1-0.4-1.6c-0.3-0.5-0.7-0.9-1.2-1.2h-0.2 c-0.1,0.1-0.2,0.3-0.4,0.4c-0.8,0.5-1.7,0.5-2.5,0l-0.3-0.4H20c-1,0.6-1.6,1.6-1.6,2.8V20L18.9,20.2z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M24,9.9l4.3-1c0.1,0,0.2-0.1,0.2-0.3l0,0c0-0.2-0.1-0.3-0.3-0.3l0,0l-4.9,1.1h0.1L24,9.9z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M24.8,11.6l4.1,2.1h0.4c0.1-0.2,0-0.4-0.1-0.4l-4.4-2.3V11.6z"
});

function SvgFireExtinguisher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireExtinguisher);
export default __webpack_public_path__ + "static/media/fire_extinguisher.2f3d50a0eb39403ed12bf3280d7fb17b.svg";
export { ForwardRef as ReactComponent };